import { IAppState } from '../../../AppModulesWrapper';

export function selectIsPublishToHiddenBase(state: IAppState): boolean {
  return state.servicePickerWidget.publishAvailable.isPublishToHiddenBase;
}
